// Notification delay constants (in seconds)
const MIN_NOTIFY_DELAY = 120; // 2 minutes
const MAX_NOTIFY_DELAY = 2400; // 40 minutes
const RELOAD_DELAY = 120000; // 2 minutes in milliseconds

// initial state
const state = {
  appEnvironment: null,
  mobile: {
    pageTitle: ''
  },
  neutronVersion: {},
  neutronVersionNotifyTimeout: null,
  homePageUrl: 'https://www.opendock.com',
  supportUrl: 'https://community.loadsmart.com/hc/en-us/community/topics/14812876253715-OpenDock',
  termsAndConditionsUrl: 'https://loadsmart.com/subscription-and-professional-services-agreement',
  privacyPolicyUrl: 'https://loadsmart.com/privacy-policy'
};

// getters
const getters = {
  s3BaseUrl(state) {
    if (state.appEnvironment?.S3_DOWNLOAD_URL) {
      return state.appEnvironment.S3_DOWNLOAD_URL;
    }

    if (state.appEnvironment?.S3_BUCKET && state.appEnvironment?.S3_BASE) {
      return `https://${state.appEnvironment.S3_BUCKET}.${state.appEnvironment.S3_BASE}`;
    }

    return null;
  }
};

// actions
const actions = {
  async getAppEnvironment({ commit }) {
    await axios.get('app-environment').then(r => {
      commit('setAppEnvironment', r.data);
    });
  },
  async getNeutronVersion({ state, commit }) {
    await axios.get('/version').then(res => {
      if (res?.data) {
        this.neutronVersion = res.data;
        commit('setNeutronVersion', res.data);
      }
    });

    return state.neutronVersion;
  },
  async verifyNeutronVersion({ state, commit }, payload) {
    if (!payload?.version?.major || !state.neutronVersion.major) {
      return;
    }
    const isSameNeutronVersion =
      payload.version.commit === state.neutronVersion.commit &&
      payload.version.major === state.neutronVersion.major &&
      payload.version.minor === state.neutronVersion.minor &&
      payload.version.patch === state.neutronVersion.patch;

    /**
     * Randomly select a number of seconds between 120 and 600 (2 to 10 minutes)
     * to wait before showing the notification and reloading the page, after 2 minutes.
     */
    if (payload.version && !isSameNeutronVersion && !state.neutronVersionNotifyTimeout) {
      const notifyFn = this.$app?.notify ?? this.notify;
      const notifyGroup = 'top-notifications';
      const randomSeconds =
        Math.floor(Math.random() * (MAX_NOTIFY_DELAY - MIN_NOTIFY_DELAY + 1)) + MIN_NOTIFY_DELAY;

      const reloadFunction = () => {
        commit('setNeutronVersion', payload.version);
        location.reload();
      };

      console.debug(
        `New app version detected: ${payload.version.commit}. Showing notification in ${Math.floor(
          randomSeconds / 60
        )} minutes...`
      );

      const notifyUser = () => {
        // Notify user about the new version
        notifyFn(
          `New app version available. Page will auto-refresh in 2 minutes for the update.`,
          'warning',
          {
            duration: -1,
            group: notifyGroup
          }
        );

        // Reload the page after 2 minutes
        setTimeout(reloadFunction, RELOAD_DELAY);
      };

      state.neutronVersionNotifyTimeout = setTimeout(notifyUser, randomSeconds * 1000);
    }
  }
};

// mutations
const mutations = {
  setAppEnvironment(state, value) {
    state.appEnvironment = value;
  },
  setMobilePageTitle(state, title) {
    state.mobile.pageTitle = title;
  },
  setNeutronVersion(state, value) {
    state.neutronVersion = value;
  }
};

export default {
  namespaced: true,
  name: 'App',
  state,
  getters,
  actions,
  mutations
};
